import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, take } from 'rxjs';
import { DesktopService } from '../services/desktop/desktop.service';

@Injectable({
  providedIn: 'root'
})
export class NotFoundPageResolver implements Resolve<boolean> {
  constructor(private desktopService: DesktopService, private router: Router) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const [categoryKey, pathKey] = Object.keys(route.params)
    let path = route.params[pathKey];
    let category = route.params[categoryKey];
    let api = this.desktopService.staticData(category, path).valueChanges;
    api.subscribe(res => {
      if (res.data.pages.length == 0) {
        this.router.navigate(['', '404']);
      }
    })
    return api.pipe(take(1));
    // console.log(, state);
    // return of(route);
  }
}
